import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Alert, Modal } from 'react-bootstrap'
import { toast } from '@CommonComponents/toast'
import { client } from '@Utils'

export const RemoveConfirmModal = ({
  modalTitle,
  message,
  endpoint,
  show,
  toggle,
  currentState,
  dispatch,
}) => {
  const [errorText, updateErrorText] = useState(null)

  const removeHandler = async () => {
    try {
      await client.delete(endpoint)
      toast.success("Successfully removed.")
      // Trigger the lower components useEffect hook
      toggle(false)
      updateErrorText(null)
      dispatch({ type: 'reload', reload: !currentState.reloadSwitch })
    } catch (err) {
      if (err.response) {
        if (err.response.status === 500) {
          toast.error(`${err.response.statusText} ${err.response.data.error}`)
        } else {
          updateErrorText(err.response.data.error)
        }
      } else {
        updateErrorText(err)
      }
    }
  }

  const closeModalHandler = () => {
    toggle(false)
    updateErrorText(null)
  }

  let errorAlert = errorText ? (
    <Alert variant="danger">{errorText}</Alert>
  ) : null

  return (
    <Modal show={show} onHide={closeModalHandler}>
      <Modal.Header closeButton>
        <Modal.Title>{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {errorAlert}
        <p>{message}</p>
        <div
          className="btn btn-danger btn-myed btn-danger-myed"
          onClick={removeHandler}
        >
          <div className="fa-regular fa-window-close fa-fw mr-2" /> Remove
        </div>
      </Modal.Body>
    </Modal>
  )
}

RemoveConfirmModal.propTypes = {
  modalTitle: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  endpoint: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  currentState: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
}
